import { ChangeDetectionStrategy, Component } from '@angular/core';

/** The two app-store badges, for screens whose real content lives in the app rather than on the web. */
@Component({
  selector: 'tnq-download-stores',
  imports: [],
  templateUrl: './download-stores.component.html',
  styleUrl: './download-stores.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadStoresComponent {}
